import React, { useState, useEffect } from 'react'
import getGender from '../../utils/getGender'
import getExamVersion from '../../utils/getExamVersion'
import StartButton from '../../elements/startButton'
import BaseEndpoint from '../../endpoints/baseEndpoint';

export default function Potential({ user, answer, disabled }) {
    const [activeId, setActiveId] = useState(null);
    const [session, setSession] = useState(null);
    const [remains, setRemains] = useState(null);
    useEffect(() => {
        if (user?.version === 'potensi-kerja') {
            BaseEndpoint.instance().get(`/exam/${user.version}/instruction?token=${user.token}`).then((response) => {
                if (response.status === 200) {
                    setSession(response.data.map((item) => {
                        return {
                            ...item,
                            name: item.version,
                        }
                    }));
                }
            });
        }

        BaseEndpoint.instance().get(`/exam/${user.version}/limit?token=${user.token}`).then((response) => {
            if (response.status === 200) {
                setRemains(response.data.remains);
            }
        });
    }, []);

    return (
        <>
            <h1 className="text-3xl font-bold mb-5 text-center">Akun anda</h1>
            <table className="table borderless" style={{ width: "40%", margin: "auto" }}>
                <tbody>
                    <tr>
                        <td>Nama</td>
                        <td>{user?.nama_lengkap}</td>
                    </tr>
                    <tr>
                        <td>No. Telepon</td>
                        <td>{user?.no_tlp || '-'}</td>
                    </tr>
                    <tr>
                        <td>Alamat email</td>
                        <td>{user?.email || '-'}</td>
                    </tr>
                    <tr>
                        <td>Tempat & Tanggal Lahir</td>
                        <td>{user?.ttl || '-'}</td>
                    </tr>
                    <tr>
                        <td>Jenis Kelamin</td>
                        <td>{getGender(user?.jenis_kelamin) || '-'}</td>
                    </tr>
                    <tr>
                        <td>Versi Ujian</td>
                        <td>{getExamVersion(user?.version) || '-'}</td>
                    </tr>
                    {remains !== null && (
                        <tr>
                            <td>Sisa Limit Pengerjaan</td>
                            <td>{remains} kali</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <StartButton version={user?.version} answer={answer} params={{
                id: activeId,
                session: session,
            }} disabled={disabled || (remains === 0)} />
        </>
    )
}